export default "__VITE_ASSET__D_PqiUL6__"